import { createAction, union, props } from '@ngrx/store';

export const setValue = createAction('PseudoLocalActions/Set', props<{ key: string; data: any }>());
export const destroyValue = createAction('PseudoLocalActions/Destroy', props<{ key: string }>());

const all = union({ setValue, destroyValue });
export type PseudoLocalActionsUnion = typeof all;
